import color from "../../../../../../constants/color";

const style = {
  headerContainer: {
    display: "flex",
    flexDirection: { xs: "column", sm: "row" },
    justifyContent: "space-between",
    alignItems: { xs: "flex-start", sm: "center" },
    paddingRight: { xs: 2, sm: 3.5 },
    gap: { xs: 2, sm: 0 }
  },
  leaveHeading: {
    fontWeight: 600,
    fontSize: "20px",
  },
  dropDownMenu: {
    fontSize: "14px",
    fontWeight: "400"
  },
  dropdown: {
    "& .css-11u53oe-MuiSelect-select-MuiInputBase-input-MuiOutlinedInput-input": {
      padding: "8.5px 14px",
    },
    // width:{ xs: "25em", md: "35em" },
    width: "100%",
    fontSize: "14px",
    fontWeight: "400",
    borderRadius: 2,
    marginTop: 1
  },
  input:
  {
    borderRadius: "8px",
    my: 1,
    height: "2.8em",
    fontSize: "14px",
    fontWeight: "400",
    " & .css-1t8l2tu-MuiInputBase-input-MuiOutlinedInput-input ": {
      fontSize: "14px",
      fontWeight: "400",
    }
  }
  ,
  jobButton: {
    borderRadius: 50,
    textTransform: "none",
    backgroundColor: "#28AA4A",
    fontSize: "12px",
    mt: 1,
  },

  gridbioBox: {
    backgroundColor: "#ffff",
    m: 3,
    p: 3,
    mr: { xs: 3, sm: 3, md: 3, lg: 0 },
    borderRadius: "20px",
    height: "fit-content",

  },
  inputSection: {
    display: "flex",
    flexDirection: { xs: "column", md: "row" },
    justifyContent: "space-between",
    px: 2,
    gap: { xs: 2, md: 3 }
  },

  optionalInput: {
    px: 2
  },

  itemGrid: {
    justifyContent: "space-between",
    alignItems: "center",
    textAlign: "center",
  },
  leaveSection: {
    px: 2
  },
  amount: {

    borderRadius: "8px",
    // my: 1,
    height: "2.8em",
    fontSize: "14px",
    fontWeight: "400",
    color: color.text,
    border: "1px solid #DEDEDE",
    paddingTop: 1,
    textAlign: "left",
    paddingLeft: 1.5

  },
  inputLabel: {
    fontSize: "12px",
    fontWeight: "500",
    color: color.text
  },
  addIcon: {
    p: 1,
    backgroundColor: "#D4EEDB",
    borderRadius: "5px",
    color: color.primary
  },
  deleteIcon: {
    p: 1,
    pb: 0,
    backgroundColor: "#FBD6D6",
    borderRadius: "5px",
    color: color.red

  },

  inputContainer: {
    // width:{xs:"18em",md:"25em",},
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "space-between"
  },
  inputContainerBox: {
    // width:{xs:"18em",md:"25em",},
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "space-between",
    mb: 1,
  },

  modalInput: {
    display: "flex",    // backgroundColor:color.lightGray,
    justifyContent: "center",// Center align on smaller screens
    my: "10px",
    height: "2.5em",
    "& .css-1t8l2tu-MuiInputBase-input-MuiOutlinedInput-input": {
      padding: "5.5px 14px",
    },
    borderRadius: "8px",
    "& .MuiOutlinedInput-root": {
      padding: "1.1px",
      borderRadius: "8px",
      "& fieldset": {
        borderRadius: "8px",
      },
    },
    width: "100%"
  },


  uploadSection: {
    px: 2,
    width: { xs: "100%", md: "55%" },

    "& .css-2y07vr": {
      py: "7px"

    }
  },
  leaveInputGrid: {
    display: { xs: "block", md: "flex" },
    alignItems: "center",
    justifyContent: "space-between"

  },
  leaveSheetGrid: {
    display: { xs: "block", md: "flex" },
    ml: { xs: 0, md: 2 },
    mt: { xs: 0, md: 2 },
    height: "fit-content"
  },
  leaveSheet: {
    border: "1px solid rgba(0, 0, 0, 0.23)",
    borderRadius: "5px",
    px: 1,
    mr: 1,
    mb: { xs: 1, md: 0 },
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",

    " & .css-0": {
      display: "flex",

    },
  },
  closeIcon: {
    fontSize: "1rem",
    ml: 2,
  },

  inputBox: {
    width: { xs: "100%", md: "49%", lg: "32%" }
  },
  inputBox1: {
    width: { xs: "100%", md: "65.5%" }
  },
  inputText: {
    fontSize: "12px",
    fontWeight: "500",
    color: color.text,
    mt: 1,
  },
  uploadText: {
    fontSize: "14px",
    fontWeight: "400",
    color: color.lightText,
    mt: 2,
    mb: 1,

  },
  gridbox: {
    backgroundColor: "#ffff",
    m: { xs: 1, sm: 2 },
    py: 2,
    px: { xs: 1, sm: 2 },
    borderRadius: "20px",
    height: "fit-content",
    overflow: "hidden",
    width: { xs: "calc(100% - 8px)", sm: "auto" }
  },
  gridboxs: {
    backgroundColor: "#ffff",
    mt: 2,
    mb: 2,
    py: 2,
    borderRadius: "20px",
    height: "fit-content",

  },

  itemSection: {
    display: "flex",
    flexDirection: { xs: "column", sm: "row" },
    mx: 2,
    alignItems: { xs: "flex-start", sm: "center" },
    width: "100%",
    gap: { xs: 2, sm: 0 }
  },
  gridText: {
    mx: 2,
    fontSize: "14px",
    fontWeight: "600"
  },
  bioBox: {
    px: 3,
    pt: 1,
  },
  content: {
    mt: 2,
    ml: 2,
    display: "flex",
    flexDirection: "row",
    // justifyContent:"space-Between"
  },
  switchSection: {
    display: "flex",
    alignItems: "center",
    mb: 1,
  },
  mainBoxes: {
    pr: { xs: 1, sm: 2 },
    display: "flex",
    flexDirection: { xs: "column", sm: "row" },
    justifyContent: { xs: "stretch", sm: "flex-end" },
    gap: { xs: 1, sm: 2 }
  },
  jobButtons: {
    borderRadius: 50,
    textTransform: "none",
    backgroundColor: "#28AA4A",
    fontSize: "14px",
    fontWeight: "500",
    ml: 2,
    px: 4,
  },
  mainContainer: {
    justifyContent: "end",
  },
  cancelButtons: {
    borderRadius: 50,
    textTransform: "none",
    backgroundColor: color.primary,
    fontSize: "14px",
    fontWeight: "500",
    px: 4,
    mb: 1

  },


  switchKeyText: {
    width: { xs: "60%", md: "32%" }
  },
  switchContent: {
    fontSize: "12px",
    fontWeight: "500",
  },
  descText: {
    fontSize: "14px",
    fontWeight: "400",
    color: color?.text,
  },
  descValueText: {
    fontSize: "14px",
    fontWeight: "500",
    color: color?.text,
  },
  descValueTexts: {
    fontSize: "14px",
    fontWeight: "600",
    color: color?.text,
  },

  infoSection: {
    px: 3,
  },
  bioIconText: {
    fontSize: "22px",
    fontWeight: "600",
  },
  textPrimary: {
    fontSize: "14px",
    fontWeight: "400",
    color: color.lightText,
  },
  line: {
    border: "1px solid #D9D9D9",
    my: 2,
    mx: 3
  },
  subHeading: {
    fontSize: "16px",
    fontWeight: "600"
  },
  contactSection: {
    mt: 4,
  },

  contenttSection: {
    mt: 2.5,
  },

  durationText: {
    fontSize: "14px",
    fontWeight: "400",
    lineHeight: "21px",

  },
  contactSubheading: {
    fontSize: "18px",
    fontWeight: "600",

  },
  infoBox: {
    display: "flex",
    mb: 1.5,
  },
  bioText: {
    fontSize: "14px",
    fontWeight: "600",
  },
  bioTextValue: {
    fontSize: "14px",
    fontWeight: "400",
    ml: 2,

  },
  bioTextValueSuccess: {
    fontSize: "14px",
    fontWeight: "400",
    ml: 2,
    color: color.primary,

  },
  detailText: {
    fontSize: "14px",
    fontWeight: "400",
    color: color.text
  },
  closeJob: {
    color: "#FF0000",
    fontSize: "14px",
  },
  removeSection: {
    display: "flex",
    alignItem: "center",
    justifyContent: "space-between",
    mt: 2,

  },
  liText: {
    fontSize: "14px",
    listStyle: "disc !important",
    display: "list-item",
  },
  createJob: {
    textAlign: "center",
  },
  lastGrid: {
    justifyContent: "space-between",
    mx: 2
  },
  dateInput: {
    width: "100%",
    my: 1,
    "& .MuiInputBase-input": {
      padding: "8.5px 14px",
      borderRadius: "8px !important"
    }
  },
  label: {
    fontSize: "12px",
    fontWeight: "500",
    color: color.text,
    mt: 1
  },
  countryCode: {
    ".react-tel-input": {
      width: "100%",
      "& .form-control": {
        width: "100%",
        height: "40px",
        fontSize: "14px"
      },
      "& .selected-flag": {
        "& .flag": {
          mt: "-9px",
        },
      },
      "@media (max-width: 600px)": {
        "& .form-control": {
          fontSize: "13px",
          height: "36px"
        }
      }
    },
  },
  addressBox: {
    display: "flex",
    flexDirection: { xs: "column", md: "row" },
    justifyContent: "space-between",
    gap: { xs: "16px", md: "3%" },
    px: { xs: 1.5, sm: 2 },
    width: "100%"
  },
  addressInput: {
    display: "flex",
    flexDirection: { xs: "column", sm: "row" },
    justifyContent: { xs: "flex-start", sm: "space-between" },
    alignItems: { xs: "stretch", sm: "center" },
    gap: { xs: 2, sm: 0 },
    my: { xs: 2, sm: 3 },
    width: "100%"
  },
  addressTextField: {
    width: "100%",
    "& .MuiOutlinedInput-root": {
      borderRadius: "8px",
      width: "100%"
    },
    "& .MuiOutlinedInput-input": {
      fontSize: { xs: "13px", sm: "14px" },
      fontWeight: 400,
      // padding: { xs: "10px 12px", sm: "14px" }
    },
    "& .MuiFormHelperText-root": {
      marginLeft: 0,
      fontSize: "12px"
    },
    "@media (max-width: 600px)": {
      marginBottom: "8px"
    }
  },

  customInput: {
    '& .MuiOutlinedInput-root': {
      paddingRight: '0px !important',
      borderRadius: '8px',
    }
  },
  inputBgBox: {
    borderRadius: '0px 8px 8px 0px',
    paddingRight: '4px',
    color: "#878787",
  },
  addressSection: {
    width: "100%",
    display: "flex",
    flexDirection: "column",
    gap: { xs: 2, sm: 3 },
    padding: { xs: "16px 12px", sm: "20px 16px" },
    backgroundColor: "#fff",
    borderRadius: "8px",
    "& .MuiFormControl-root": {
      width: "100%"
    }
  }
};

export default style;